module.exports = __webpack_public_path__ + "media/55.741f3dbe.mp3";